export const ChatMessageType = Object.freeze({
    TEXT:'TEXT',
    AUDIO:'AUDIO',
    VIDEO:'VIDEO',
    POLL:'POLL',
    IMAGE:'IMAGE'
})
export const ChatType = Object.freeze({
    PRIVATE:'PRIVATE',
    GROUP:'GROUP'
})